var _g, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPropsReviewRefine = function SvgPropsReviewRefine(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 25 36",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4d523c",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.21948 7.93896v22.53664",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.0732 1.5v33",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9268 4.71948v28.17072",
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.21951,
    cy: 22.4268,
    fill: "#4d523c",
    r: 3.21951
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9268,
    cy: 15.9878,
    fill: "#4d523c",
    r: 3.21951
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0731,
    cy: 12.7683,
    fill: "#f6f0eb",
    r: 2.46951,
    stroke: "#4d523c",
    strokeWidth: 1.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPropsReviewRefine);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgMjUgMzYiIHdpZHRoPSIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiM0ZDUyM2MiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJtMy4yMTk0OCA3LjkzODk2djIyLjUzNjY0IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48cGF0aCBkPSJtMTIuMDczMiAxLjV2MzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjxwYXRoIGQ9Im0yMC45MjY4IDQuNzE5NDh2MjguMTcwNzIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjwvZz48Y2lyY2xlIGN4PSIzLjIxOTUxIiBjeT0iMjIuNDI2OCIgZmlsbD0iIzRkNTIzYyIgcj0iMy4yMTk1MSIvPjxjaXJjbGUgY3g9IjIwLjkyNjgiIGN5PSIxNS45ODc4IiBmaWxsPSIjNGQ1MjNjIiByPSIzLjIxOTUxIi8+PGNpcmNsZSBjeD0iMTIuMDczMSIgY3k9IjEyLjc2ODMiIGZpbGw9IiNmNmYwZWIiIHI9IjIuNDY5NTEiIHN0cm9rZT0iIzRkNTIzYyIgc3Ryb2tlLXdpZHRoPSIxLjUiLz48L3N2Zz4=";